import React from 'react';
import { Link } from 'react-router-dom';
import '../CSS/styles.css';
const Contact = () => {
  return (
    <div className='container col-xxl-8 px-4 py-5'>
      <div className='row flex-lg-row-reverse align-items-center g-5 py-5'>
        <div className='col-lg-6'>
          <div className='feature col'>
            <div className='feature-icon'>
              <h2 className='fw-light titleStyle'>Benjamin Anoh</h2>

              <h5>Software Engineer | Photographer</h5>
            </div>
            <p className='pt-3 text-secondary'>
              My name is Ben. I build software and create portrait photography.
            </p>
            <p className='text-secondary'>
              My photography focuses on portraits and lifestyle sessions. I aim
              to capture personality, identity, and emotion through natural
              posing and thoughtful direction. I look forward to helping you
              preserve meaningful moments.
            </p>
            <div className=''>
              <ul className='nav col-12 col-lg-auto my-2 justify-content-left my-md-0 text-small'>
                <li className=''>
                  <Link
                    to='/apps'
                    className='footer-social-link'
                    aria-label='View iOS apps'>
                    <i className='fab fa-app-store-ios' aria-hidden='true'></i>
                  </Link>
                </li>
                <li className=''>
                  <a
                    href='https://www.linkedin.com/in/kadjo-b-a-1bb753a9/'
                    className='footer-social-link'
                    aria-label='View LinkedIn profile'>
                    <i className='fab fa-linkedin-in' aria-hidden='true'></i>
                  </a>
                </li>
                <li className=''>
                  <a
                    href='https://www.instagram.com/ben_anoh/?hl=en'
                    className='footer-social-link'
                    aria-label='View Instagram profile'>
                    <i className='fab fa-instagram' aria-hidden='true'></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className='col-sm-6 col-lg-6'>
          <img
            src={require(`../Download/ben.jpg`)}
            className='portrait-image d-block mx-lg-auto img-fluid'
            alt='Benjamin Anoh portrait'
            loading='lazy'
          />
        </div>
      </div>
    </div>
  );
};

export default Contact;
